import React from 'react';
import { Periodo } from '@monorepo-web/components-library';
import { useAppDispatch, useAppSelector, setDataPersonalizada } from '@monorepo-web/logic-extrato';
import { IObjDatas } from '@monorepo-web/utils';

interface IPeriodoWrapper {
  periodo: string;
  obj_datas: IObjDatas;
  disabled: boolean;
  onChange: (value: any) => void;
}

export default function PeriodoWrapper(props: IPeriodoWrapper) {
  const [dataInicialCarteira, dataFinalCarteira] = useAppSelector((state) => [
    state.preference.dateStart,
    state.preference.dateEnd,
  ]);
  const dispatch = useAppDispatch();

  const onSelectAplicar = ({dataIni, dataFim}: {dataIni: string; dataFim: string}) => {
    dispatch(setDataPersonalizada({ dataIni: dataIni, dataFim: dataFim }));
  }

  return (
    <Periodo
      periodo={props.periodo}
      obj_datas={props.obj_datas}
      disabled={props.disabled}
      onChange={props.onChange}
      dataInicialCarteira={dataInicialCarteira}
      dataFinalCarteira={dataFinalCarteira}
      onSelectAplicar={onSelectAplicar}
    />
  );
}
